<template lang="pug">
  y-dialog(v-model="showDialog" :fullscreen="$vuetify.breakpoint.xsOnly" max-width="600" persistent scrollable content-class="round-3xl")
    v-card
      v-card-title.pa-0
        div(style="width: 100%")
          v-row.pa-4(no-gutters align="center")
            v-col(cols="10" offset="1")
              div.text-xl.font-bold.neutral700--text.text-center {{ $t('set_appointment') }}
            v-col(cols="1" align="right")
              v-btn.ml-n3(text icon @click="closeDialog")
                v-icon(color="neutral700" :size="24") mdi-close
          v-divider
      v-card-text.pa-8.neutral700--text
        template(v-if="hasConfirmedAppointment")
          .d-flex.flex-column.justify-center.align-center
            v-icon.mb-8(color="success500" size="75") mdi-check-circle
            .text-md.font-semibold {{ $t('new_appointment_made') }}
            .text-sm.text-center.neutral500--text.mb-8 {{ $t('new_appointment_made_description') }} 
              span.font-semibold.underline.neutral700--text {{ $t('undo') }}
        template(v-else)
          appointment-details(ref="details")
            template(#title)
              .text-md.font-semibold.neutral700--text {{ $t('set_appointment_description') }}
      v-divider
      v-card-actions.py-4(:class="$vuetify.breakpoint.xsOnly ? 'px-4' : 'px-8'")
        y-button(v-if="!hasConfirmedAppointment" label="Advanced appointment" underline button-class="px-0" @click="openAdvance()")
        v-btn.button-md.underline.px-0(v-else text :loading="isLoadingLeftButton" @click="onCancelOrUndo") {{ $t('undo') }}
        v-spacer
        v-btn.button-md(:loading="isLoading" color="neutral700" dark depressed @click="onSaveOrDone") {{ hasConfirmedAppointment ? $t('done') : $t('confirm') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AppointmentDetails from '@/components/clinic/appointment/AppointmentDetails.vue'

export default {
  components: { AppointmentDetails },
  props: {
    open: {
      type: Boolean,
    },
    patient: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      isLoadingLeftButton: false,
      confirmedAppointment: null
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      appointment: 'clinic/getTempAppointment'
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    },
    payload () {
      let data = {
        date: this.appointment.form.date,
        time: this.appointment.form.time,
        service: this.appointment.form.service,
        provider: this.appointment.form.provider,
        patient: this.patient.id
      }
      if (this.appointment.form.remarks) {
        data.lead = { remarks: this.appointment.form.remarks }
      }
      if (this.appointment.override) {
        data.ignore_rules = [ 'service_prep_time' ]
      }
      return data
    },
    hasConfirmedAppointment () {
      return this.confirmedAppointment !== null
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    async onSaveOrDone () {
      if (this.hasConfirmedAppointment) {
        this.closeDialog()
        return
      }
      if (!this.$refs.details.$refs.form.validate()) {
        return
      }
      try {
        this.isLoading = true
        const endpoint = `/clinics/${this.company.slug}/appointments`
        const resp = await this.$axios.post(endpoint, this.payload)
        this.updateActivityLog(endpoint, this.payload, resp, 'POST')
        this.confirmedAppointment = resp.data
        this.showMessage(['success', this.$t('success_message.successfully_updated')])
      } catch (error) {
        let message = this.$t('error_message.unable_to_complete_request')
        if (error.response.data?.detail) {
          message = error.response.data.detail
        }
        this.showMessage(['error', message])
      } finally {
        this.isLoading = false
      }
    },
    openAdvance () {
      this.$emit('advance')
    },
    closeDialog () {
      this.showDialog = false
      this.$emit('closed')
    },
    async onCancelOrUndo () {
      if (this.hasConfirmedAppointment) {
        this.isLoadingLeftButton = true
        try {
          await this.$axios.patch(`/clinics/${this.company.slug}/appointments/${this.confirmedAppointment.id}`, { status: 'cancelled' })
          this.showMessage(['success', this.$t('success_message.successfully_updated')])
        // eslint-disable-next-line no-empty
        } catch (error) {}
        this.isLoadingLeftButton = false
      }
      this.closeDialog()
    },
    updateActivityLog (endpoint, payload, response, method, id) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: 'appointment',
        activity: 'Create new appointment',
        raw_data: { endpoint, payload, response: response.data, method}
      }
      this.$axios.post('/users/logs', data).catch(() => {})
    }
  },
  beforeDestroy () {
    this.$store.commit('clinic/resetTempAppointment')
  }
}
</script>

<style scoped>
.main-container {
  position: relative;
}
.separator {
  position: absolute;
  height:3px;
  top: 38px;
  left: 0px;
  right: 0px;
}
</style>